module.exports = new __parcel__URL__("logoInLadakh.e9c9fdd7.png").toString();